import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-900 flex flex-col justify-center py-12 sm:px-6 lg:px-8" }
const _hoisted_2 = { class: "mt-6 sm:mx-auto sm:w-full sm:max-w-md" }
const _hoisted_3 = { class: "bg-gray-800 py-8 px-6 shadow-md sm:rounded-lg sm:px-10 border border-gray-700" }
const _hoisted_4 = {
  key: 0,
  class: "text-center"
}
const _hoisted_5 = { class: "text-gray-400 mb-6" }
const _hoisted_6 = { class: "space-y-3" }
const _hoisted_7 = {
  key: 0,
  class: "bg-green-900 border border-green-700 text-green-300 px-3 py-2 rounded relative text-sm",
  role: "alert"
}
const _hoisted_8 = { class: "block sm:inline" }
const _hoisted_9 = {
  key: 1,
  class: "bg-red-900 border border-red-700 text-red-300 px-3 py-2 rounded relative text-sm",
  role: "alert"
}
const _hoisted_10 = { class: "block sm:inline" }
const _hoisted_11 = {
  key: 2,
  class: "text-center"
}
const _hoisted_12 = {
  key: 3,
  class: "text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_FormInput = _resolveComponent("FormInput")!
  const _component_FormButton = _resolveComponent("FormButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "sm:mx-auto sm:w-full sm:max-w-md" }, [
      _createElementVNode("h2", { class: "text-center text-2xl md:text-3xl font-extrabold text-white" }, " Postavite novu lozinku "),
      _createElementVNode("p", { class: "mt-2 text-center text-sm text-gray-400" }, " Unesite vašu novu lozinku ")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.tokenError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "text-red-400 text-6xl mb-4" }, "✗", -1)),
              _cache[8] || (_cache[8] = _createElementVNode("h3", { class: "text-xl font-semibold text-white mb-2" }, " Neispravan token ", -1)),
              _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.tokenError), 1),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_router_link, {
                  to: "/forgot-password",
                  class: "block w-full bg-indigo-600 text-white px-4 py-2 rounded-md hover:bg-indigo-700 text-center"
                }, {
                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createTextVNode(" Zatražite novi link ")
                  ])),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: "/login",
                  class: "block text-center text-indigo-400 hover:text-indigo-300"
                }, {
                  default: _withCtx(() => _cache[6] || (_cache[6] = [
                    _createTextVNode(" Nazad na prijavu ")
                  ])),
                  _: 1
                })
              ])
            ]))
          : (_openBlock(), _createElementBlock("form", {
              key: 1,
              onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleResetPassword && _ctx.handleResetPassword(...args)), ["prevent"])),
              class: "space-y-6"
            }, [
              _createVNode(_component_FormInput, {
                id: "password",
                name: "password",
                type: "password",
                label: "Nova lozinka",
                modelValue: _ctx.formData.password,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.password) = $event)),
                placeholder: "Nova lozinka",
                required: "",
                error: _ctx.errors.password,
                onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.validateField('password')))
              }, null, 8, ["modelValue", "error"]),
              _createVNode(_component_FormInput, {
                id: "confirm-password",
                name: "confirm-password",
                type: "password",
                label: "Potvrdi lozinku",
                modelValue: _ctx.formData.confirmPassword,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.confirmPassword) = $event)),
                placeholder: "Potvrdi lozinku",
                required: "",
                error: _ctx.errors.confirmPassword,
                onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.validateField('confirmPassword')))
              }, null, 8, ["modelValue", "error"]),
              (_ctx.successMessage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.successMessage), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.serverError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.serverError), 1)
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_FormButton, {
                type: "submit",
                loading: _ctx.isLoading,
                disabled: _ctx.isLoading || !_ctx.isFormValid,
                class: "w-full"
              }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [
                  _createTextVNode(" Postavite novu lozinku ")
                ])),
                _: 1
              }, 8, ["loading", "disabled"]),
              (_ctx.resetSuccess)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createVNode(_component_FormButton, {
                      onClick: _ctx.goToLogin,
                      class: "w-full"
                    }, {
                      default: _withCtx(() => _cache[10] || (_cache[10] = [
                        _createTextVNode(" Idite na prijavu ")
                      ])),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createVNode(_component_router_link, {
                      to: "/login",
                      class: "text-indigo-400 hover:text-indigo-300 text-sm"
                    }, {
                      default: _withCtx(() => _cache[11] || (_cache[11] = [
                        _createTextVNode(" Nazad na prijavu ")
                      ])),
                      _: 1
                    })
                  ]))
            ], 32))
      ])
    ])
  ]))
}